import { Navigate, useParams } from 'react-router-dom';

/**
 * Legacy URL was /update-user_setting/{subId:userId}. Modern URL is
 * /user-settings/edit/{subId}/{userId}. Forward old links to the new
 * shape so deep links and bookmarks keep working during the migration.
 */
export function UpdateUserSettingLegacyRedirect() {
  const { ids } = useParams<{ ids: string }>();
  const [subId = '0', userId = '0'] = (ids ?? '').split(':');
  return <Navigate to={`/user-settings/edit/${subId}/${userId}`} replace />;
}
